<template>
  <Modal :id="id" size="tiny" ok-title="关闭" hide_cancel="true" title="标签管理">
    <div class="field">
      <div class="ui fluid action input">
        <input id="new-tag-name" name="new-tag-name" maxlength="128" v-model.trim="new_tag" class="form-control" type="text" @keyup.enter="create_tag"/>
        <button class="ui button" @click="create_tag">新建标签</button>
      </div>
    </div>
    <div class="ui items">
      <div class="ui item" v-for="t in tag_data" :key="t.name">
        <div>
          <i class="text-gray-600 tag icon"></i>
          {{ t.name }}
        </div>
        <div class="ml-auto">
          <a href="javascript:void(0)"
             v-if="t.entries == 0"
             class="deleteicon ml-1"
             @click="delete_tag(t)">
            <i class="ui red text trash alternate icon"></i>
          </a>
          ({{ t.entries}} 个项目)
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from './modal.vue';

export default {
  name: 'TagManage',
  props: ['id'],
  components: {
    Modal,
  },
  data: function () {
    return {
      new_tag: '',
    };
  },
  computed: {
    pwdata() {
      return this.$store.state.pwdata;
    },
    tag_data() {
      var r = this.pwdata.tags.map(t => this.build_tag_data(t));
      return r.sort((x, y) => { return y.entries - x.entries });
    },
  },
  methods: {
    build_tag_data(t) {
      return {
        name: t,
        entries: this.pwdata.entries.filter(e => e.tags.includes(t)).length,
      };
    },
    create_tag() {
      if (!this.new_tag) {
        this.show_error("标签不能为空");
        return;
      }
      if (this.tag_data.some(t => t.name == this.new_tag)) {
        this.show_error("标签已存在");
        return;
      }
      var tag = this.new_tag;
      this.new_tag = '';
      this.$store.dispatch('pwdata_create_tag', tag).then(() => {
        this.show_success("标签已创建: " + tag);
      }).catch(e => {
        this.show_error("添加标签失败: " + e.message);
      });
    },
    async delete_tag(t) {
      if (t.entries) {
        this.show_error('不能删除非空的标签');
        return;
      }
      try {
        this.$store.dispatch('delete_tag', t.name);
        this.show_success('标签"' + t.name + '"已删除');
      } catch (e) {
        this.show_error('标签删除失败：' + e.message);
      }
    },
  },
  mounted() {
  },
}
</script>

<style scoped>
a.deleteicon:hover {
  color: #e00 !important;
}
</style>
